<div class="delete-confirmation">
  <div>
      <div class="confirmation-line1"><h4>Are you sure you would like to Delete this Form?</h4></div>
      <!-- <div class="confirmation-line2">Note: This will remove any existing data entered for this implement and its associated components.
      </div> -->
  </div>

  <div class="button-container" style="margin-bottom: 10%;">
      <a class="button button-no" (click)="onCloseClick()">
          <span class="button__text">No</span>
      </a>
      <a class="button button--primary button-yes" (click)="onConfirmDeleteClick()">
          <span class="button__text">Yes</span>
      </a>
  </div>
</div>
